import React from 'react';
import { cn } from './cn';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'text' | 'danger';
type ButtonSize = 'sm' | 'md';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
}

const variants: Record<ButtonVariant, string> = {
  primary: 'border-ds-primary bg-ds-primary text-white hover:border-ds-primary-strong hover:bg-ds-primary-strong',
  secondary: 'border-ds-200 bg-ds-white text-ds-800 hover:bg-ds-subtle',
  ghost: 'border-transparent bg-transparent text-ds-700 hover:bg-ds-subtle',
  text: 'border-transparent bg-transparent text-ds-primary-strong hover:bg-ds-primary-soft',
  danger: 'border-ds-danger bg-ds-danger text-white hover:opacity-90',
};

const sizes: Record<ButtonSize, string> = {
  sm: 'h-9 px-2.5 text-xs',
  md: 'h-10 px-3.5 text-[13px]',
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant = 'primary', size = 'md', fullWidth, type = 'button', ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex shrink-0 items-center justify-center gap-2 rounded-ds-6 border font-bold transition-colors duration-150 active:scale-[.97] disabled:pointer-events-none disabled:opacity-50',
        variants[variant],
        sizes[size],
        fullWidth && 'w-full',
        className,
      )}
      {...props}
    />
  );
});
